import React, {useEffect, useState} from 'react'
import './FilterSidebar.sass'
import moment from "moment";
import {observer} from "mobx-react";
import FilterSidebarTemplate from "./FilterSidebarTemplate";

const dateInitial = {
    startDate: new Date(),
    endDate: null,
    key: 'selection'
}

const inputInitial = {
    fio: '',
    medBook: '',
	resultStudyType: '',
    organization: '',
    verCenter: '',
    medCenter: '',
    inn: '',
    name: '',
    city: '',
    specialization: '',
    type: '',
    checked: '',
    doctor: ''
}

const FilterSidebar = observer((props) => {
    const [date, setDate] = useState([
        dateInitial
    ])
    const [result, selectResult] = useState()
    const [period, selectPeriod] = useState()
    const [status, selectStatus] = useState()
    const [multiSelect, setMultiSelect] = useState({specialization: []})
    const [select, setSelect] = useState({})
    const [base, selectBase] = useState()
    const [filterData, setFilterData] = useState(inputInitial)

    function clean() {
        setDate([dateInitial])
        selectBase(null)
        selectPeriod(null)
        selectStatus(null)
        selectResult(null)
        setFilterData(inputInitial)
        setMultiSelect({specialization: []})
        setSelect({city: '', type: '', checked: ''})
        props.filterChangeURL('')

    }

    function handleChange(e) {
        setFilterData({...filterData, [e.target.name]: e.target.value})
        selectResult(null)
    }

    function selectHandler(key, value) {
        setSelect(prev     => ({...prev, [key]: value}))
        setFilterData(prev => ({...prev, [key]: value.value}))
    }

    function multiSelectHandler(key, selected) {
        const options = selected.map(option => option.value)
        setMultiSelect(prev => ({...prev, [key]: selected}))
        setFilterData(prev => ({...prev, [key]: `[${options.map(item => '"' + item + '"').join(',')}]`}))
        if (options.length === 0) {
            setFilterData({...filterData, [key]: ''})
        }
    }

    const urlGenerator = () => {
        const haveToFilter = [
            filterData.medBook ? 'med_book=' + encodeURIComponent(filterData.medBook) : '',
            filterData.resultStudyType ? 'result_study_type=' + encodeURIComponent(filterData.resultStudyType) : '',
            filterData.fio ? 'fio=' + encodeURIComponent(filterData.fio) : '',
            filterData.doctor ? 'doctor=' + encodeURIComponent(filterData.doctor) : '',
            filterData.city ? 'city=' + encodeURIComponent(filterData.city) : '',
            filterData.checked ? 'checked=' + filterData.checked : '',
            filterData.type ? 'type=' + filterData.type : '',
            filterData.specialization ? 'specialization=' + encodeURIComponent(filterData.specialization) : '',
            filterData.organization ? 'org_name=' + encodeURIComponent(filterData.organization) : '',
            filterData.medCenter ? 'med_name=' + encodeURIComponent(filterData.medCenter) : '',
            filterData.inn ? 'inn=' + encodeURIComponent(filterData.inn) : '',
            filterData.name ? 'name=' + encodeURIComponent(filterData.name) : '',
            filterData.verCenter ? 'verification_center=' + encodeURIComponent(filterData.verCenter) : '',
            date[0].startDate ? 'dateFrom=' + moment(date[0].startDate).format('YYYY-MM-DD') : '',
            date[0].endDate ? 'dateTo=' + moment(date[0].endDate).format('YYYY-MM-DD') : '',
            base ? 'base=' + base.value : '',
            result ? 'result=' + result.value : '',
            status ? 'status=' + status.value : '',
        ]
        let url = ''

        haveToFilter.forEach((option) => {
            if (option) {
                url = url + option + '&'
            }
        })
        props.filterChangeURL(url)
    }
    useEffect(() => {
        if (period) {
            setDate([{
                ...date[0],
                startDate: period.value[0],
                endDate: period.value[1]
            }])
        }
    }, [period])
    return <FilterSidebarTemplate filterData={filterData}
                                  handleChange={handleChange}
                                  filterComponent={props.filterComponent}
                                  selectResult={selectResult}
                                  result={result}
                                  period={period}
                                  status={status}
                                  multiSelect={multiSelect}
                                  selectStatus={selectStatus}
                                  selectPeriod={selectPeriod} selectPlace={selectBase}
                                  base={base} filterFieldsConf={props.filterFieldsConf} date={date}
                                  setDate={setDate} urlGenerator={urlGenerator} clean={clean}
                                  style={props.style} showFilter={props.showFilter}
                                  filterBarButtons={props.filterBarButtons}
                                  addOrg={props.addOrg}
                                  select={select}
                                  selectHandler={selectHandler}
                                  exportTemplateButtons={props.exportTemplateButtons}
                                  multiSelectHandler={multiSelectHandler}

    />


})
export default FilterSidebar
